import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PrintModule } from '@app/dashboard/print/print.module';
import { SharedModule } from '@app/sharedModule/shared.module';
import { StorybookModule } from '@app/storybook/storybook.module';
import { FulfillSidePanelBatchTableComponent } from '@pages/workspace/fulfill/components/fulfill-side-panel-batch-table/fulfill-side-panel-batch-table.component';
import { FulfillBatchListDeliveryReadyComponent } from './components/fulfill-batch-list-delivery-ready/fulfill-batch-list-delivery-ready.component';
import { FulfillBatchListFulfillmentReadyComponent } from './components/fulfill-batch-list-fulfillment-ready/fulfill-batch-list-fulfillment-ready.component';
import { FulfillBatchListTableRowComponent } from './components/fulfill-batch-list-table-row/fulfill-batch-list-table-row.component';
import { FulfillBatchListTableV2Component } from './components/fulfill-batch-list-table-v2/fulfill-batch-list-table-v2.component';
import { FulfillBatchListV2Component } from './components/fulfill-batch-list-v2/fulfill-batch-list-v2.component';
import { FulfillBatchListComponent } from './components/fulfill-batch-list/fulfill-batch-list.component';
import { FulfillHeaderComponent } from './components/fulfill-header/fulfill-header.component';
import { FulfillSidePanelBatchComponent } from './components/fulfill-side-panel-batch/fulfill-side-panel-batch.component';
import { FulfillSidePanelOrderFooterComponent } from './components/fulfill-side-panel-order-footer/fulfill-side-panel-order-footer.component';
import { FulfillSidePanelOrderHeaderComponent } from './components/fulfill-side-panel-order-header/fulfill-side-panel-order-header.component';
import { FulfillSidePanelOrderInfoComponent } from './components/fulfill-side-panel-order-info/fulfill-side-panel-order-info.component';
import { FulfillSidePanelOrderItemsComponent } from './components/fulfill-side-panel-order-items/fulfill-side-panel-order-items.component';
import { FulfillSidePanelOrderComponent } from './components/fulfill-side-panel-order/fulfill-side-panel-order.component';
import { FulfillSidePanelScanComponent } from './components/fulfill-side-panel-scan/fulfill-side-panel-scan.component';
import { FulfillSidePanelUpdateBannerComponent } from './components/fulfill-side-panel-update-banner/fulfill-side-panel-update-banner.component';
import { FulfillSidePanelComponent } from './components/fulfill-side-panel/fulfill-side-panel.component';
import { FulfillPageComponent } from './fulfill.component';

// PIPES
import { FulfillBatchHistoryModalComponent } from './components/fulfill-batch-history-modal/fulfill-batch-history-modal.component';
import { FulfillSidePanelOrderItemCardComponent } from './components/fulfill-side-panel-order-item-card/fulfill-side-panel-order-item-card.component';
import { filterBatchesPipe, onlyWithOrdersPipe } from './utils/fulfillPipes';

// DIALOGS (POPUP)
import { A11yModule } from '@angular/cdk/a11y';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MultipleFulfillmentDialog } from '@pages/workspace/fulfill/components/fulfill-side-panel-batch-table/dialog/multiple-fulfillment.dialog';
import { SwitchOrderPackageComponent } from '@pages/workspace/fulfill/components/fulfill-side-panel-order-items/components/switch-order-package/switch-order-package.component';
import { ScannedOrderMultipleResults } from '@pages/workspace/fulfill/components/fulfill-side-panel-scan/components/scan-multiple-options/scan-multiple-options';
import { VoidModalComponent } from './components/fulfill-back-to-assign-btn/components/void-modal/void-modal.component';
import { FulfillBackToAssignBtnComponent } from './components/fulfill-back-to-assign-btn/fulfill-back-to-assign-btn.component';
import { ShippingManifestCreateComponent } from './components/fulfill-shipping-manifests/shipping-manifest-create/shipping-manifest-create.component';
import { ShippingManifestsListComponent } from './components/fulfill-shipping-manifests/shipping-manifests-list/shipping-manifests-list.component';
import { OrderInfoTrackingNumberComponent } from './components/fulfill-side-panel-order-info/order-info-tracking-number/order-info-tracking-number.component';
import { FulfillMsgDialogComponent } from './components/fulfill-side-panel-order-items/components/fulfill-msg-dialog/fulfill-msg-dialog.component';
import { FulfillScanPackageDialog } from './dialogs/fulfill-scan-package-dialog/fulfill-scan-package-dialog';
import { FulfillTrialDialog } from './dialogs/fulfill-trial-dialog/fulfill-trial-dialog';

@NgModule({
  imports: [
    StorybookModule,
    CommonModule,
    SharedModule,
    PrintModule,
    MatProgressSpinnerModule,
    ScrollingModule,
    A11yModule,
  ],
  declarations: [
    FulfillPageComponent,
    FulfillHeaderComponent,
    FulfillSidePanelComponent,
    FulfillBatchListComponent,
    FulfillBatchListV2Component,
    FulfillBatchListFulfillmentReadyComponent,
    FulfillBatchListTableV2Component,
    FulfillBatchListDeliveryReadyComponent,
    FulfillBatchListTableRowComponent,
    FulfillSidePanelScanComponent,
    FulfillSidePanelBatchComponent,
    FulfillSidePanelOrderComponent,
    FulfillSidePanelOrderHeaderComponent,
    FulfillSidePanelOrderInfoComponent,
    FulfillSidePanelOrderItemsComponent,
    FulfillSidePanelOrderFooterComponent,
    filterBatchesPipe,
    onlyWithOrdersPipe,
    FulfillSidePanelOrderItemCardComponent,
    FulfillBatchHistoryModalComponent,
    FulfillSidePanelBatchTableComponent,
    MultipleFulfillmentDialog,
    FulfillBackToAssignBtnComponent,
    VoidModalComponent,
    FulfillTrialDialog,
    FulfillSidePanelUpdateBannerComponent,
    SwitchOrderPackageComponent,
    OrderInfoTrackingNumberComponent,
    FulfillMsgDialogComponent,
    ShippingManifestsListComponent,
    ShippingManifestCreateComponent,
    ScannedOrderMultipleResults,
    FulfillScanPackageDialog,
  ],
  exports: [
    RouterModule,
    FulfillHeaderComponent,
    FulfillSidePanelComponent,
    FulfillBatchListComponent,
    filterBatchesPipe,
  ],
})
export class FulfillPageModule {}
